import { c as _c } from "react/compiler-runtime";
import { CloseOutlined } from '@ant-design/icons';
import Image from 'next/image';
import { Modal } from '@/ui/molecules/modal';
import type { GalleryContentProps } from '@/services/sanity';
type MediaModalProps = {
  open: boolean;
  onClose: () => void;
  item: GalleryContentProps | null;
};
export function MediaModal(t0) {
  const $ = _c(27);
  const {
    open,
    onClose,
    item
  } = t0;
  if (!item) {
    return null;
  }
  const {
    mediaType,
    image,
    video,
    title,
    brainRegion
  } = item;
  const mediaUrl = mediaType === "video" ? video : image;
  if (!mediaUrl) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: 0,
      left: 0,
      transform: "none",
      height: "100vh",
      width: "100vw"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CloseOutlined className="text-xl" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = <button type="button" onClick={onClose} aria-label="Close modal" className="absolute top-4 right-4 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-black/50 text-white transition-colors hover:bg-black/70">{t2}</button>;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = item.has_background && item.backgroundColor ? item.backgroundColor : undefined;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      backgroundColor: t4,
      padding: "1rem",
      borderRadius: "0.5rem"
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== image || $[7] !== mediaType || $[8] !== title || $[9] !== video) {
    t6 = mediaType === "video" ? <video src={video || ""} controls={true} className="h-auto max-h-[calc(100vh-2rem)] w-auto max-w-[calc(100vw-2rem)] object-contain" autoPlay={true}><track kind="captions" />Your browser does not support the video tag.</video> : <Image src={image || ""} alt={title || "Gallery image"} width={1920} height={1080} className="h-auto max-h-[calc(100vh-2rem)] w-auto max-w-[calc(100vw-2rem)] object-contain" unoptimized={true} sizes="100vw" />;
    $[6] = image;
    $[7] = mediaType;
    $[8] = title;
    $[9] = video;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex items-center justify-center" style={t5}>{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== title) {
    t8 = <div className="font-bold">{title}</div>;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== brainRegion) {
    t9 = brainRegion && <div className="capitalize"><span className="text-neutral-3">Brain Region:</span> {brainRegion}</div>;
    $[16] = brainRegion;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="fixed right-4 bottom-4 z-[400] bg-black/70 px-5 py-4 font-sans text-base font-normal text-white">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== onClose || $[22] !== open || $[23] !== t10 || $[24] !== t3 || $[25] !== t7) {
    t11 = <Modal open={open} onClose={onClose} maskClosable={true} closable={false} title="" position="custom" className="!fixed !inset-0 !h-screen !max-h-none !w-screen !max-w-none !translate-x-0 !translate-y-0 !rounded-none !bg-transparent !shadow-none" overlayClassName="!bg-black/70" bodyClassName="!relative !p-0 !overflow-hidden !h-full !max-h-none !flex !items-center !justify-center !min-h-full" headerClassName="!hidden" closeIconClassName="!text-white !text-2xl hover:!text-gray-300" animation="fade" style={t1}>{t3}{t7}{t10}</Modal>;
    $[21] = onClose;
    $[22] = open;
    $[23] = t10;
    $[24] = t3;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}